/**
 * @fileoverview Responsive layout state and Register page background effect.
 * @module pages/register/useRegisterScreenSize
 */
import { useEffect, useState } from "react";
import SmallLoginBackground from "../../assets/SmallLoginBackground.png";
import Background from "../../assets/Background.png";
import {
  MEDIUM_MOBILE_MAX_WIDTH_PX,
  MEDIUM_MOBILE_MIN_WIDTH_PX,
  SMALL_MOBILE_MAX_WIDTH_PX,
  TABLET_MAX_WIDTH_PX,
  TABLET_MIN_WIDTH_PX,
} from "./registerFormHelpers.js";

const useRegisterScreenSize = () => {
  const [isTablet, setIsTablet] = useState(false);
  const [isMediumMobile, setIsMediumMobile] = useState(false);
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsTablet(width >= TABLET_MIN_WIDTH_PX && width <= TABLET_MAX_WIDTH_PX);
      setIsMediumMobile(
        width >= MEDIUM_MOBILE_MIN_WIDTH_PX &&
          width <= MEDIUM_MOBILE_MAX_WIDTH_PX,
      );
      setIsSmallMobile(width < SMALL_MOBILE_MAX_WIDTH_PX);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const isMobile = isTablet || isMediumMobile || isSmallMobile;
    const backgroundImage = isMobile
      ? `url('${SmallLoginBackground}')`
      : `url('${Background}')`;

    document.body.style.backgroundImage = backgroundImage;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";

    return () => {
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
      document.body.style.backgroundPosition = "";
      document.body.style.backgroundRepeat = "";
      document.body.style.backgroundAttachment = "";
    };
  }, [isTablet, isMediumMobile, isSmallMobile]);

  return { isTablet, isMediumMobile, isSmallMobile };
};

export default useRegisterScreenSize;
